import { useMemo, useState } from "react";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { PreWithCopy } from "../../Monitor/components/LogViews";
import { formatDateTime } from "../utils";
import TraceEventRow from "./TraceEventRow";

const RENDER_WINDOW = 200;

const ScreenOpenRow = ({ screenOpen, expanded, onToggle }) => (
  <div className="timeline_row">
    <span className="timeline_dot screen" />
    <div className="timeline_row_header" onClick={onToggle}>
      <span className="timeline_seq">0</span>
      <MaterialIcon name="visibility" />
      <span className="status_pill screen">Screen open</span>
      <span className="timeline_label">
        {screenOpen?.screen_name || "Screen"} · {formatDateTime(screenOpen?.created_at)}
        {screenOpen?.ip_address ? ` · ${screenOpen.ip_address}` : ""}
      </span>
      <MaterialIcon name={expanded ? "expand_less" : "expand_more"} />
    </div>
    {expanded && (
      <div className="timeline_expanded_body">
        <PreWithCopy label="Screen open details" value={screenOpen} />
      </div>
    )}
  </div>
);

const TraceTimeline = ({ events, screenOpen }) => {
  const [expanded, setExpanded] = useState(() => new Set());
  const [screenExpanded, setScreenExpanded] = useState(false);
  const [visibleCount, setVisibleCount] = useState(RENDER_WINDOW);

  const maxMs = useMemo(() => Math.max(1, ...(events || []).map((e) => e?.duration_ms || 0)), [events]);

  const toggle = (index) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const visibleEvents = (events || []).slice(0, visibleCount);

  return (
    <div className="audit_timeline">
      {screenOpen && (
        <ScreenOpenRow
          screenOpen={screenOpen}
          expanded={screenExpanded}
          onToggle={() => setScreenExpanded((v) => !v)}
        />
      )}
      {visibleEvents.map((event, index) => (
        <TraceEventRow
          key={`${event?.source}-${event?.source_row_id}-${index}`}
          event={event}
          sequence={event?.sequence || index + 1}
          maxMs={maxMs}
          expanded={expanded.has(index)}
          onToggle={() => toggle(index)}
        />
      ))}
      {(events || []).length > visibleCount && (
        <div className="timeline_show_more">
          <span>
            Showing {visibleCount} of {events.length} events
          </span>
          <button
            className="builder_input"
            style={{ cursor: "pointer" }}
            onClick={() => setVisibleCount((c) => c + RENDER_WINDOW)}
          >
            Show {Math.min(RENDER_WINDOW, events.length - visibleCount)} more
          </button>
        </div>
      )}
    </div>
  );
};

export default TraceTimeline;
